import { createApp } from 'vue'
import { createHead } from '@vueuse/head'

import App from './App.vue'
import router from './router'
import { initializeCsrf } from './utils/axiosinstance'
import './utils/authInterceptor'
import { isSeoEnabled } from './utils/seoEnv'
import { initClarity } from './utils/clarity'
import 'flag-icons/css/flag-icons.min.css';

// Import design system variables
import './assets/styles/variables.css'
// Inter Variable — the admin theme's typeface. Registered under the family
// name 'Inter Variable', which nothing on the public site asks for, so this
// self-hosted font reaches the back-office only. (The stack had named 'Inter'
// for months without anything ever loading it.)
import '@fontsource-variable/inter'
// Shared design system for every admin page
import './assets/styles/admin-theme.css'

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.css";

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import 'vue-sonner/style.css'

// Microsoft Clarity — dev box only, see utils/clarity.ts. Started outside the
// CSRF promise so recording still happens on the degraded fallback mount below.
initClarity(router)

// Initialize CSRF protection
initializeCsrf().then(() => {
  const app = createApp(App)
  const head = createHead()
  app.use(head)
  app.use(router);

// Google Analytics — production only. useProductionMetaTags() is NOT called
// here: App.vue already calls it from inside a component setup, which is where
// @vueuse/head can actually apply it. Gating on the runtime env rather than
// VITE_NODE_ENV keeps dev-box traffic out of the production GA property.
if (isSeoEnabled()) {
  const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = window.gtag || gtag;

  window.gtag('js', new Date());
  window.gtag('config', gaId);

  router.afterEach((to) => {
    window.gtag('event', 'page_view', {
      page_path: to.fullPath,
      page_location: window.location.href,
      page_title: document.title
    });
  });
}


  app.mount('#app')
}).catch(err => {
  console.error('Failed to initialize app:', err.message || err);
  // Mount app anyway for public pages
  const app = createApp(App)
  app.use(router);
  app.mount('#app')
});
